import { RulesSushiLunch } from "../modules/rulesSushiLunch";

export const RulesSushiLunchPage = () => {
  return <RulesSushiLunch />;
};
